module.exports = {
	"ha": "nha",
	"id": 5.3,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2019 Q1–2020 Q4",
		"lastYear": "2020",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 60,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.3</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Northern Health by Age Category, Year Ending 2020 Q4 <sup style=\"font-size: 10px;\">8</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -195,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "55%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "55%",
				"height": "45%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -80,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 73.07692307692307,
						"dataLabels": {
							"enabled": true,
							"format": "19",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 57.692307692307686,
						"dataLabels": {
							"enabled": true,
							"format": "15",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 53.84615384615385,
						"dataLabels": {
							"enabled": true,
							"format": "14",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 46.15384615384615,
						"dataLabels": {
							"enabled": true,
							"format": "12",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 19.230769230769234,
						"dataLabels": {
							"enabled": true,
							"format": "5",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": true,
							"format": "42",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 78.57142857142857,
						"dataLabels": {
							"enabled": true,
							"format": "33",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 76.19047619047619,
						"dataLabels": {
							"enabled": true,
							"format": "32",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 64.28571428571429,
						"dataLabels": {
							"enabled": true,
							"format": "27",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 26.190476190476193,
						"dataLabels": {
							"enabled": true,
							"format": "11",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 97.22222222222221,
						"dataLabels": {
							"enabled": true,
							"format": "70",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 88.88888888888889,
						"dataLabels": {
							"enabled": true,
							"format": "64",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 83.33333333333334,
						"dataLabels": {
							"enabled": true,
							"format": "60",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 62.5,
						"dataLabels": {
							"enabled": true,
							"format": "45",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 22.22222222222222,
						"dataLabels": {
							"enabled": true,
							"format": "16",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 97.60479041916167,
						"dataLabels": {
							"enabled": true,
							"format": "163",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 80.23952095808383,
						"dataLabels": {
							"enabled": true,
							"format": "134",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 77.84431137724552,
						"dataLabels": {
							"enabled": true,
							"format": "130",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 73.05389221556887,
						"dataLabels": {
							"enabled": true,
							"format": "122",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 40.119760479041915,
						"dataLabels": {
							"enabled": true,
							"format": "67",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -26.923076923076927,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -21.052631578947366,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -6.666666666666665,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -14.28571428571429,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -58.33333333333333,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -21.42857142857143,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.0303030303030276,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -15.625,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -59.25925925925925,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -2.777777777777779,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -8.571428571428575,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -6.25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -64.44444444444444,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -2.39520958083832,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -17.791411042944784,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -2.985074626865669,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -6.153846153846154,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -45.08196721311475,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "< 30<br>n=26"
			},
			{
				"x": 9,
				"text": "30–39<br>n=42"
			},
			{
				"x": 15,
				"text": "40–49<br>n=72"
			},
			{
				"x": 21,
				"text": "≥ 50<br>n=167"
			}
		],
		"dataTable": {
			"< 30": [
				26,
				19,
				15,
				14,
				12,
				5
			],
			"30–39": [
				42,
				42,
				33,
				32,
				27,
				11
			],
			"40–49": [
				72,
				70,
				64,
				60,
				45,
				16
			],
			"≥ 50": [
				167,
				163,
				134,
				130,
				122,
				67
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_5_3.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_nha_5_3.json
// module id = 270
// module chunks = 0